// import Vue from 'vue'

const DEFAULT_STATE = {
  articles: [],
  read: []
}

export default {
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    articles(state) {
      const aWhileAgo = new Date((new Date()).valueOf() - (15 * 24 * 3600 * 1000))
      return state.articles.map(article => {
        article.unread = article.date > aWhileAgo && state.read.indexOf(article.id) < 0
        return article
      })
    },
    unreadArticles(state, getters) {
      return getters.articles.filter(article => article.unread)
    },
    unreadCount(state, getters) {
      return getters.unreadArticles.length
    }
  },
  mutations: {
    setArticles(state, articles) {
      state.articles = articles
    },
    setRead(state, id) {
      state.read.push(id)
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE)
    }
  },
  actions: {
    fetch(context) {
      /* Vue.http.get('news.php')
      .then(response => {
        let discourseNews = []
        let articles = []
        try {
          discourseNews = response.body.topic_list.topics
        } catch (e) {}
        discourseNews.forEach(article => {
          const id = article.id
          if (id === 17) return
          const titleData = article.title.split('#')
          const title = titleData.shift().trim()
          const articleLangs = titleData.map(lang => lang.trim())
          const isTranslated = articleLangs.length > 0
          const myLanguage = Vue.config.language === 'fr' ? 'FR' : 'EN'
          const isMyLanguage = articleLangs.indexOf(myLanguage) > -1
          const date = new Date(article.created_at)
          if (isTranslated && !isMyLanguage) return
          const url = `https://community.meteo-parapente.com/t/${article.slug}/${article.id}/1`
          articles.push({
            title,
            id,
            url,
            date
          })
          articles.sort((a, b) => {
            return a.date < b.date
          })
          articles = articles.slice(0, 5)
        })
        // articles.reverse()
        context.commit('setArticles', articles)
      }) */
    },
    setRead(context, id) {
      context.commit('setRead', id)
    },
    resetStore(context) {
      context.commit('resetStore')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/news.js